// Angular dependencies
import { Component } from '@angular/core';

// Rxjs dependencies
import { Observable } from 'rxjs/Observable';

// App dependencies
import { Creep } from '../creep/creep';

// Store
import { Store } from '@ngrx/store';
import { AppState, selectCreeps } from '../store.module';

@Component({
  selector: 'app-page-main',
  templateUrl: './page-main.component.html',
  styleUrls: ['./page-main.component.scss']
})
export class PageMainComponent {
  public creeps$: Observable<Creep[]>;

  constructor(
    private _store: Store<AppState>
  ) {
    this.creeps$ = this._store.select(selectCreeps);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/page-main.component.ts